export const TAB_TYPES = {
  EXPLORE: 'EXPLORE',
  MY_IDEAS: 'MY_IDEAS',
  INVESTMENTS: 'INVESTMENTS',
  CHALLENGES: 'CHALLENGES',
  NONE: 'NONE',
}
